import React from 'react'
import { Helmet } from 'react-helmet'

function Error404() {
  return (
    <>
    <Helmet>
                <meta name='description' content='page not found'/>
                <title>404 - Tisson Lanka</title>
                <link rel="canonical" href="*" />
    </Helmet>
    <div className='h-auto mx-auto text-center w-max'>
        <div className='h-4'></div>
        <h1 className='text-2xl md:text-6xl'>Page Not Found!</h1>
       <div className=' w-[400px] md:w-[600px] '>
       <img src="/404.png" alt="" />
       <div>
        <a href="/Home">
        <button type="button" className='px-4 py-2 text-2xl text-white bg-blue-700'>Home</button></a>
       </div>
       </div>
       </div>
    </>
  )
}

export default Error404